module.exports = __webpack_public_path__ + "img/phone-incoming-success.5725768b.svg";